import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { Search } from 'lucide-react';

const Navbar = () => {
  return (
    <nav className="bg-white border-b border-gray-200 sticky top-0 z-50 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <Link to="/" className="flex items-center space-x-2">
            <img src="/iso-logo-tuclinicapp.png" alt="TuClinicApp Logo" className="h-8 w-8" />
            <span className="text-2xl font-bold text-gray-800">Tu ClinicApp</span>
          </Link>
          
          <div className="flex items-center space-x-4">
            <Link to="/clinicas">
              <Button className="bg-cyan-500 hover:bg-cyan-600 text-white">
                <Search className="h-4 w-4 mr-2" />
                Ver Directorio
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
